/** Enum listing all possible labels an assignment can have */
export enum AssignmentLabels {
  IMPORTANT = 'IMPORTANT',
}
